"use strict";

!(function ($) {
  if ($(".tabs_list").length) {
    // Click function
    $(".tabs_list .tab_item").click(function (e) {
      e.preventDefault();
      let tabContent = $(this).attr("tab-conten")
      $(".tabs_list .tab_item").removeClass("active");
      $(this).addClass("active");
      $(".grid-product").hide().removeClass("slide");
      if( !tabContent || tabContent == 'alle' ) {
        $(".grid-product")
        .fadeIn()
        .addClass("slide");
      } else {
        $(".grid-product." + tabContent)
        .fadeIn()
        .addClass("slide");
      }
      
      if ($(window).width() <= 767.98) {
        $(".collection_grid_master").slick("refresh");
      }
      return false;
    });
  }
  $(".modal-info-toggle").on("click", function (e) {
    e.preventDefault();
    $(".modal-info." + $(this).attr("modal-info")).toggleClass("is-visible");
  });
  function mobile_only_collection_grid_carousel() {
    if ($(".collection_grid_master").length) {
      if ($(window).width() <= 767.98) {
        $(".collection_grid_master").slick({
          arrows: true,
          dots: true,
          slidesToShow: 1,
          adaptiveHeight: true,
          slide: ".slide",
          speed: 500,
          fade: true,
          cssEase: "linear",
        });
      } else {
        $(".collection_grid_master").slick("unslick");
      }
    }
  }
  mobile_only_collection_grid_carousel();
  $(window).resize(function () {
    mobile_only_collection_grid_carousel();
  });
})(jQuery);
